import React from "react";
import MainLayout from "./MainLayout";
import ChecklistDetails from "../common/OnBoarding/SkillChecklist/OnBoardingSkillRatings";

const ChecklistDetailsPage = (props) => <MainLayout component={ChecklistDetails} />;

export default ChecklistDetailsPage;
